<template>
  <b-overlay :show="isLoading" rounded="sm">
    <b-card>
      <div class="mb-3 w-100 d-flex align-items-center">
        <h1>Add New Representative</h1>
      </div>
      <b-row>
        <b-col cols="12" md="6">
          <b-form @submit.prevent>
            <b-form-group label="Representative Name" label-for="name">
              <b-form-input
                id="name"
                trim
                placeholder="Enter representative name"
                v-model="representativeDetails.name"
              />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col cols="12" md="6">
          <b-form @submit.prevent>
            <b-form-group label="Owner Name" label-for="ownerName">
              <b-form-input
                id="ownerName"
                trim
                placeholder="Enter owner name"
                v-model="representativeDetails.ownerName"
              />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col cols="12" md="6">
          <b-form @submit.prevent>
            <b-form-group
              label="Representative Phonenumbers (Separate with -)"
              label-for="phone"
            >
              <b-form-input
                id="phone"
                trim
                placeholder="Enter representative phonenumbers"
                v-model="representativeDetails.phone"
              />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label-for="state" label="Representative City">
            <b-form-select
              id="state"
              v-model="representativeDetails.state"
              :options="stateOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Representative address" label-for="address">
            <b-form-textarea
              id="address"
              v-model="representativeDetails.address"
              rows="2"
              placeholder="Enter representative address"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <div class="w-100 d-flex align-items-center justify-content-end">
        <b-button variant="success" @click="createNewRepresentativeRequest">
          Create
        </b-button>
      </div>
    </b-card>
  </b-overlay>
</template>
<script>
export default {
  title: "Add New Representative",
  data() {
    return {
      isLoading: false,
      representativeDetails: {
        isDeleted: false,
        representativeId: 0,
        name: null,
        ownerName: null,
        address: null,
        phone: null,
        seourl: null,
        seoTitle: null,
        seoDescription: null,
        // 1 is for tehran
        // 2 is for others
        state: null,
        createDate: new Date(Date.now()).toISOString(),
      },
      stateOptions: [
        {
          value: null,
          text: "Please choose an option",
        },
        {
          value: 1,
          text: "Tehran",
        },
        {
          value: 2,
          text: "Other cities",
        },
      ],
    };
  },
  methods: {
    async createNewRepresentativeRequest() {
      try {
        this.isLoading = true;
        let _this = this;
        let createNewRepresentative = new CreateNewRepresentative(_this);
        createNewRepresentative.setRequestParamDataObj(
          _this.representativeDetails
        );
        await createNewRepresentative.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "Operation Was Succesful",
                icon: "CheckIcon",
                variant: "success",
                text: "Representative Added Succesfully",
              },
            });
            _this.representativeDetails = {
              isDeleted: false,
              representativeId: 0,
              name: null,
              ownerName: null,
              address: null,
              phone: null,
              seourl: null,
              seoTitle: null,
              seoDescription: null,
              // 1 is for tehran
              // 2 is for others
              state: null,
              createDate: new Date(Date.now()).toISOString(),
            };
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BContainer,
    BPagination,
    BFormRow,
    BCard,
    BMedia,
    BAvatar,
    BCardText,
    BTable,
    BMediaAside,
    BMediaBody,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BImg,
    BFormFile,
    BLink,
    BButton,
    BFormTextarea,
    BOverlay,
    BFormSelect,
  },
};
import {
  BContainer,
  BPagination,
  BFormRow,
  BCard,
  BMedia,
  BAvatar,
  BCardText,
  BTable,
  BMediaAside,
  BMediaBody,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BImg,
  BFormFile,
  BLink,
  BButton,
  BFormTextarea,
  BOverlay,
  BFormSelect,
} from "bootstrap-vue";
import { CreateNewRepresentative } from "@/libs/Api/Representative";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
</script>
